import { TextInput, Textarea, Paper, Text, Flex, Button } from "@mantine/core";

interface ProductServiceItemFormProps {
  index: number;
  type: "product" | "service";
  data: any;
  onChange: (field: string, value: any) => void;
  onRemove: () => void;
  isViewMode?: boolean;
  errors?: { name?: string; description?: string };
}

const ProductServiceItemForm = ({
  index,
  type,
  data,
  onChange,
  onRemove,
  isViewMode = false,
  errors,
}: ProductServiceItemFormProps) => {
  const itemLabel = `${type === "product" ? "Product" : "Service"} ${index + 1}`;

  return (
    <Paper shadow="none" p="lg" radius="md" withBorder mb="lg" style={{ borderColor: "#E5E7EB" }}>
      <Flex justify="space-between" align="center" mb="md">
        <Text fw={500}>{itemLabel}</Text>
        {!isViewMode && (
          <Flex gap="sm" align="center">
            <Button variant="subtle" color="red" size="sm" onClick={onRemove}>
              Remove
            </Button>
          </Flex>
        )}
      </Flex>

      <TextInput
        label={`${type === "product" ? "Product" : "Service"} Name`}
        placeholder={type === "product" ? "e.g., M8 Hex Bolts" : "e.g., CNC Machining Service"}
        required
        mb="md"
        w="50%"
        value={data.name || ""}
        onChange={(e) => onChange("name", e.target.value)}
        readOnly={isViewMode}
        error={errors?.name}
      />

      <Textarea
        label="Description"
        placeholder={
          type === "product"
            ? "Describe the product specifications, materials, standards..."
            : "Describe the service, capabilities, turnaround time..."
        }
        required
        mb="md"
        autosize
        minRows={5}
        value={data.description || ""}
        onChange={(e) => onChange("description", e.target.value)}
        readOnly={isViewMode}
        error={errors?.description}
      />
    </Paper>
  );
};

export default ProductServiceItemForm;
